/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SigninRouteRouteImport } from './routes/signin/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SigninIndexRouteImport } from './routes/signin/index'
import { Route as AppWhatifRouteImport } from './routes/_app/whatif'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as SigninEmailIndexRouteImport } from './routes/signin/email/index'
import { Route as SigninEmailFinishRouteImport } from './routes/signin/email/finish'
import { Route as AppWhatifIncomeSubmissionTopicIdRouteImport } from './routes/_app/whatif_/income-submission.$topicId'
import { Route as AppSurveysSurveyIdSubmissionsRouteImport } from './routes/_app/surveys.$surveyId/submissions'
import { Route as AppSurveysSurveyIdSubmissionsSubmissionIdIndexRouteImport } from './routes/_app/surveys.$surveyId/submissions_.$submissionId/index'
import { Route as AppSurveysSurveyIdTopicsTopicIdSubmissionRouteImport } from './routes/_app/surveys.$surveyId/topics_.$topicId/submission'
import { Route as AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRouteImport } from './routes/_app/surveys.$surveyId/submissions_.$submissionId/$subtopicId'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRouteRoute = SigninRouteRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninIndexRoute = SigninIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SigninRouteRoute,
} as any)
const AppWhatifRoute = AppWhatifRouteImport.update({
  id: '/whatif',
  path: '/whatif',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const SigninEmailIndexRoute = SigninEmailIndexRouteImport.update({
  id: '/email/',
  path: '/email/',
  getParentRoute: () => SigninRouteRoute,
} as any)
const SigninEmailFinishRoute = SigninEmailFinishRouteImport.update({
  id: '/email/finish',
  path: '/email/finish',
  getParentRoute: () => SigninRouteRoute,
} as any)
const AppWhatifIncomeSubmissionTopicIdRoute =
  AppWhatifIncomeSubmissionTopicIdRouteImport.update({
    id: '/whatif_/income-submission/$topicId',
    path: '/whatif/income-submission/$topicId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSurveysSurveyIdSubmissionsRoute =
  AppSurveysSurveyIdSubmissionsRouteImport.update({
    id: '/surveys/$surveyId/submissions',
    path: '/surveys/$surveyId/submissions',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSurveysSurveyIdSubmissionsSubmissionIdIndexRoute =
  AppSurveysSurveyIdSubmissionsSubmissionIdIndexRouteImport.update({
    id: '/surveys/$surveyId/submissions_/$submissionId/',
    path: '/surveys/$surveyId/submissions/$submissionId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSurveysSurveyIdTopicsTopicIdSubmissionRoute =
  AppSurveysSurveyIdTopicsTopicIdSubmissionRouteImport.update({
    id: '/surveys/$surveyId/topics_/$topicId/submission',
    path: '/surveys/$surveyId/topics/$topicId/submission',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRoute =
  AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRouteImport.update({
    id: '/surveys/$surveyId/submissions_/$submissionId/$subtopicId',
    path: '/surveys/$surveyId/submissions/$submissionId/$subtopicId',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/signin': typeof SigninRouteRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/dashboard': typeof AppDashboardRoute
  '/profile': typeof AppProfileRoute
  '/settings': typeof AppSettingsRoute
  '/whatif': typeof AppWhatifRoute
  '/signin/': typeof SigninIndexRoute
  '/signin/email/finish': typeof SigninEmailFinishRoute
  '/signin/email/': typeof SigninEmailIndexRoute
  '/surveys/$surveyId/submissions': typeof AppSurveysSurveyIdSubmissionsRoute
  '/whatif/income-submission/$topicId': typeof AppWhatifIncomeSubmissionTopicIdRoute
  '/surveys/$surveyId/submissions/$submissionId/$subtopicId': typeof AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRoute
  '/surveys/$surveyId/topics/$topicId/submission': typeof AppSurveysSurveyIdTopicsTopicIdSubmissionRoute
  '/surveys/$surveyId/submissions/$submissionId/': typeof AppSurveysSurveyIdSubmissionsSubmissionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/dashboard': typeof AppDashboardRoute
  '/profile': typeof AppProfileRoute
  '/settings': typeof AppSettingsRoute
  '/whatif': typeof AppWhatifRoute
  '/signin': typeof SigninIndexRoute
  '/signin/email/finish': typeof SigninEmailFinishRoute
  '/signin/email': typeof SigninEmailIndexRoute
  '/surveys/$surveyId/submissions': typeof AppSurveysSurveyIdSubmissionsRoute
  '/whatif/income-submission/$topicId': typeof AppWhatifIncomeSubmissionTopicIdRoute
  '/surveys/$surveyId/submissions/$submissionId/$subtopicId': typeof AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRoute
  '/surveys/$surveyId/topics/$topicId/submission': typeof AppSurveysSurveyIdTopicsTopicIdSubmissionRoute
  '/surveys/$surveyId/submissions/$submissionId': typeof AppSurveysSurveyIdSubmissionsSubmissionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/signin': typeof SigninRouteRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/whatif': typeof AppWhatifRoute
  '/signin/': typeof SigninIndexRoute
  '/signin/email/finish': typeof SigninEmailFinishRoute
  '/signin/email/': typeof SigninEmailIndexRoute
  '/_app/surveys/$surveyId/submissions': typeof AppSurveysSurveyIdSubmissionsRoute
  '/_app/whatif_/income-submission/$topicId': typeof AppWhatifIncomeSubmissionTopicIdRoute
  '/_app/surveys/$surveyId/submissions_/$submissionId/$subtopicId': typeof AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRoute
  '/_app/surveys/$surveyId/topics_/$topicId/submission': typeof AppSurveysSurveyIdTopicsTopicIdSubmissionRoute
  '/_app/surveys/$surveyId/submissions_/$submissionId/': typeof AppSurveysSurveyIdSubmissionsSubmissionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signin'
    | '/onboarding'
    | '/dashboard'
    | '/profile'
    | '/settings'
    | '/whatif'
    | '/signin/'
    | '/signin/email/finish'
    | '/signin/email/'
    | '/surveys/$surveyId/submissions'
    | '/whatif/income-submission/$topicId'
    | '/surveys/$surveyId/submissions/$submissionId/$subtopicId'
    | '/surveys/$surveyId/topics/$topicId/submission'
    | '/surveys/$surveyId/submissions/$submissionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/dashboard'
    | '/profile'
    | '/settings'
    | '/whatif'
    | '/signin'
    | '/signin/email/finish'
    | '/signin/email'
    | '/surveys/$surveyId/submissions'
    | '/whatif/income-submission/$topicId'
    | '/surveys/$surveyId/submissions/$submissionId/$subtopicId'
    | '/surveys/$surveyId/topics/$topicId/submission'
    | '/surveys/$surveyId/submissions/$submissionId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/signin'
    | '/onboarding'
    | '/_app/dashboard'
    | '/_app/profile'
    | '/_app/settings'
    | '/_app/whatif'
    | '/signin/'
    | '/signin/email/finish'
    | '/signin/email/'
    | '/_app/surveys/$surveyId/submissions'
    | '/_app/whatif_/income-submission/$topicId'
    | '/_app/surveys/$surveyId/submissions_/$submissionId/$subtopicId'
    | '/_app/surveys/$surveyId/topics_/$topicId/submission'
    | '/_app/surveys/$surveyId/submissions_/$submissionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  SigninRouteRoute: typeof SigninRouteRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin/': {
      id: '/signin/'
      path: '/'
      fullPath: '/signin/'
      preLoaderRoute: typeof SigninIndexRouteImport
      parentRoute: typeof SigninRouteRoute
    }
    '/_app/whatif': {
      id: '/_app/whatif'
      path: '/whatif'
      fullPath: '/whatif'
      preLoaderRoute: typeof AppWhatifRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/signin/email/': {
      id: '/signin/email/'
      path: '/email'
      fullPath: '/signin/email/'
      preLoaderRoute: typeof SigninEmailIndexRouteImport
      parentRoute: typeof SigninRouteRoute
    }
    '/signin/email/finish': {
      id: '/signin/email/finish'
      path: '/email/finish'
      fullPath: '/signin/email/finish'
      preLoaderRoute: typeof SigninEmailFinishRouteImport
      parentRoute: typeof SigninRouteRoute
    }
    '/_app/whatif_/income-submission/$topicId': {
      id: '/_app/whatif_/income-submission/$topicId'
      path: '/whatif/income-submission/$topicId'
      fullPath: '/whatif/income-submission/$topicId'
      preLoaderRoute: typeof AppWhatifIncomeSubmissionTopicIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/surveys/$surveyId/submissions': {
      id: '/_app/surveys/$surveyId/submissions'
      path: '/surveys/$surveyId/submissions'
      fullPath: '/surveys/$surveyId/submissions'
      preLoaderRoute: typeof AppSurveysSurveyIdSubmissionsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/surveys/$surveyId/submissions_/$submissionId/': {
      id: '/_app/surveys/$surveyId/submissions_/$submissionId/'
      path: '/surveys/$surveyId/submissions/$submissionId'
      fullPath: '/surveys/$surveyId/submissions/$submissionId/'
      preLoaderRoute: typeof AppSurveysSurveyIdSubmissionsSubmissionIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/surveys/$surveyId/topics_/$topicId/submission': {
      id: '/_app/surveys/$surveyId/topics_/$topicId/submission'
      path: '/surveys/$surveyId/topics/$topicId/submission'
      fullPath: '/surveys/$surveyId/topics/$topicId/submission'
      preLoaderRoute: typeof AppSurveysSurveyIdTopicsTopicIdSubmissionRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/surveys/$surveyId/submissions_/$submissionId/$subtopicId': {
      id: '/_app/surveys/$surveyId/submissions_/$submissionId/$subtopicId'
      path: '/surveys/$surveyId/submissions/$submissionId/$subtopicId'
      fullPath: '/surveys/$surveyId/submissions/$submissionId/$subtopicId'
      preLoaderRoute: typeof AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppProfileRoute: typeof AppProfileRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppWhatifRoute: typeof AppWhatifRoute
  AppSurveysSurveyIdSubmissionsRoute: typeof AppSurveysSurveyIdSubmissionsRoute
  AppWhatifIncomeSubmissionTopicIdRoute: typeof AppWhatifIncomeSubmissionTopicIdRoute
  AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRoute: typeof AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRoute
  AppSurveysSurveyIdTopicsTopicIdSubmissionRoute: typeof AppSurveysSurveyIdTopicsTopicIdSubmissionRoute
  AppSurveysSurveyIdSubmissionsSubmissionIdIndexRoute: typeof AppSurveysSurveyIdSubmissionsSubmissionIdIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppProfileRoute: AppProfileRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppWhatifRoute: AppWhatifRoute,
  AppSurveysSurveyIdSubmissionsRoute: AppSurveysSurveyIdSubmissionsRoute,
  AppWhatifIncomeSubmissionTopicIdRoute: AppWhatifIncomeSubmissionTopicIdRoute,
  AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRoute:
    AppSurveysSurveyIdSubmissionsSubmissionIdSubtopicIdRoute,
  AppSurveysSurveyIdTopicsTopicIdSubmissionRoute:
    AppSurveysSurveyIdTopicsTopicIdSubmissionRoute,
  AppSurveysSurveyIdSubmissionsSubmissionIdIndexRoute:
    AppSurveysSurveyIdSubmissionsSubmissionIdIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface SigninRouteRouteChildren {
  SigninIndexRoute: typeof SigninIndexRoute
  SigninEmailFinishRoute: typeof SigninEmailFinishRoute
  SigninEmailIndexRoute: typeof SigninEmailIndexRoute
}

const SigninRouteRouteChildren: SigninRouteRouteChildren = {
  SigninIndexRoute: SigninIndexRoute,
  SigninEmailFinishRoute: SigninEmailFinishRoute,
  SigninEmailIndexRoute: SigninEmailIndexRoute,
}

const SigninRouteRouteWithChildren = SigninRouteRoute._addFileChildren(
  SigninRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  SigninRouteRoute: SigninRouteRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
